module.exports = __webpack_public_path__ + "img/liqpay.89f60d36.svg";